<script>
    import {onMount} from 'svelte';
    import {PATH_PREFIX} from '../../apiUrls.js';
    import {get} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import {submit} from '../Form/utils.js';
    import {validateForm} from '../Form/utils.js';

    import DataTable from '../DataGrid/DataTable.svelte';
    import TextColumn from '../DataGrid/ColumnRenderers/TextColumn.svelte';
    import SelectColumn from '../DataGrid/ColumnRenderers/SelectColumn.svelte';

    import Errors from '../Errors.svelte';
    import Modal from '../Modal.svelte';

    import yup, {object, number, string} from 'yup';

    export let formModalId = 'd2BranchMetadataFilterConfigurationForm';
    export let onSubmit = (data) => data;
    export let requireReload = false;
    export let filterConfig = null;

    let branchFilterOptionsUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-setting-filter-options/`; 
    let branchFilterUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-setting-filter/`;

    let title = sgettext('$$CONFIGURE_METADATA_FILTERS_BRANCH$$');
    let duplicateError = sgettext('$$ONE_ROWS_CONTAIN_DUPLICATE_FILTERS$$');
    let isValid = true;
    let sending = false;
    let loading = false;
    let formErrors = null;

    let filtersMarkedForRemoval = [];


    $: filterData = [];
    $: filterOptionsData = [];

    let rowSchema = object().shape({
        filter_id: string()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
        filter_value: string()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
    });

    $: filterColumns = {
        filter_id: {
            label: sgettext('$$D2_METADATA_FILTER$$'),
            tooltip: sgettext('$$COPY_FILTER_VALUES_DOCUMENTUM_ASIS_DATA$$'),
            renderer: SelectColumn,
            width: '45%',
            props: {
                options: filterOptionsData,
                placeholder: ''
            }
        },
        filter_value: {
            label: sgettext('$$FILTER_VALUE$$'),
            renderer: TextColumn,
            width: '40%',
        }
    }

    function handleFilterRemove(item) {
        if (item.id && item.existing) {
            filtersMarkedForRemoval = [...filtersMarkedForRemoval, {...item, expire: true}]
        }
        filterData = filterData.filter(t => t.id !== item.id);
    }

    let filterRowActions = {
        remove: {
            iconClass: 'fas fa5-trash-alt',
            handler: (_, item) => {
                handleFilterRemove(item);
            }
        }
    }


    function getDefaultConfig() {
        return {
            filter_id: null,
            filter_value: null,
            existing: false,
            fieldValidations: getDefaultConfigFieldIsValid(),
        };
    }   
    
    function getDefaultConfigFieldIsValid() {
        return {
            filter_id: {
                isValid: true,
                errors: '',
            },
            filter_value: {
                isValid: true,
                errors: '',
            },
        };
    }


    async function submitForm() {
        sending = true;
        const method = 'POST';
        let url = `${branchFilterUrl}`;

        try {
            await handleFormValidation();
            let payload = {};
            payload['branch_id'] = filterConfig.branch_id;
            payload['filters'] = filterData;
            payload['filters_to_expire'] = filtersMarkedForRemoval;
            if (isValid) {
                await submit(url, method, payload);
                requireReload = true;
                handleConfigClose();
            }
        } catch (error) {
            console.log(error)
            formErrors = sgettext('$$FAILED_SAVE_NEW_FILTERS$$');
        }
        sending = false;
    }


    async function handleFormValidation() {
        let validateIndex = 0;
        let filtersChecked = new Set();
        try {
            for (let row of filterData) {
                row.fieldValidations = getDefaultConfigFieldIsValid()
                await validateForm(rowSchema, row);
                
                const filterKey = `${row.filter_id}-${row.filter_value}`;
                
                if (filtersChecked.has(filterKey)) {
                    throw new Error(duplicateError);
                }
                filtersChecked.add(filterKey);
                validateIndex++;
            }
            isValid = true;
        } catch (err) {
            isValid = false;
            if (err.inner) {
                err.inner.forEach((er) => {
                    filterData[validateIndex].fieldValidations[er.path].isValid = false;
                    filterData[validateIndex].fieldValidations[er.path].errors = er.message;
                });
            } else if (err.message === duplicateError){
                filterData[validateIndex].fieldValidations.filter_value.isValid = false;
                filterData[validateIndex].fieldValidations.filter_value.errors = err.message;
            }
        }
    }


    async function handleCreateNewFilter() {
        filterData = [...filterData, getDefaultConfig()]
    }

    function handleConfigSave() {
        submitForm();
    }

    function handleConfigClose() {
        jQuery(`#${formModalId}`).modal('hide');
        isValid = true;
        loading = false;
        formErrors = null;
        filterConfig = null;
        filtersMarkedForRemoval = [];
        filterOptionsData = [];
        filterData = [];
    }

    async function fetchResults() {
        loading = true;
        var url = `${branchFilterOptionsUrl}?d2_repository=${filterConfig.d2_repository}`;
        const resp = await get(url);
        const json = await resp.json();
        if (json) {
            filterOptionsData = json["results"].map(r => ({id: r.id, name: r.filter_display_name, filter_value: r.filter_display_name, existing:false, fieldValidations: getDefaultConfigFieldIsValid()}));
        }
        loading = false;
    }

    async function fetchBranchFilterResults() {
        loading = true;
        var url = `${branchFilterUrl}?branch_id=${filterConfig.branch_id}`;
        const resp = await get(url);
        const json = await resp.json();
        if (json) {
            filterData = json["d2_configured_filters"].map(r => ({id: r.id, filter_id: r.d2_filter, filter_value: r.filter_value, existing:true, fieldValidations: getDefaultConfigFieldIsValid()}));
            filterData = filterData.length ? filterData : [getDefaultConfig()];
        }
        loading = false;
    }

    $: if (filterConfig) {
        fetchResults();
        fetchBranchFilterResults();
    }
</script>

<Modal
  id={formModalId}
  {title}
  backdrop={'static'}
  large={true}
  onCancel={handleConfigClose}
  onSave={handleConfigSave}
>
  <div slot="body">
    {#if loading}
      <div class="text-center">
        <i class="fas fa-spinner fa-spin" />
      </div>
    {:else}
      <slot name="message">
        <Errors errors={formErrors} />
        {#if filtersMarkedForRemoval.length}
          <div class="alert alert-warning">
            {sgettext(
              '$$WARNING_DELETION_FILTERS_USED_DOCUMENT$$'
            )}
          </div>
        {/if}
        <DataTable
          columns={filterColumns}
          rows={filterData}
          rowActions={filterRowActions}
          schema={rowSchema}
          emptyLabel={sgettext('$$D2_METADATA_FILTERS_CONFIGURED$$')}
          sortFunction={(a, b) => a.filter_id - b.filter_id}
          {sending}
        />
        <div class="form-group mt-1">
          <div class="actions d-flex flex-nowrap justify-content-end">
            <button
              class="btn btn-outline-primary"
              role="button"
              on:click={handleCreateNewFilter}
            >
              {sgettext('$$ADD_FILTER$$')}
            </button>
          </div>
        </div>
      </slot>
    {/if}
  </div>
</Modal>
